<template>
  <div v-cloak class="user-message">
    <div class="titles-right">个人信息</div>
    <div class="message">
      <div class="userimg">
        <img v-if="imageUrl" :src="imageUrl" class="avatar" />
        <img src="../img/moren.png" alt="" v-else />
        <el-upload
          class="avatar-uploader"
          id="upl"
          action
          :show-file-list="false"
          :http-request="picUpload"
          :before-upload="beforeAvatarUpload"
          >修改图片</el-upload
        >
      </div>
      <div class="names">
        <span>姓名：</span>
        <el-input @input="names" type="text" v-model="uname"></el-input>
      </div>
      <div class="names">
        <span>昵称：</span>
        <el-input type="text" v-model="nickName"></el-input>
      </div>
      <div class="names">
        <span>电话：</span>
        <div
          v-if="!uphone"
          class="pa-b-10 pa-t-10 c-p"
          @click="bindWeiXindialogVisible = true"
        >
          绑定手机号
        </div>
        <el-input
          v-else
          disabled
          type="text"
          placeholder="请输入手机号"
          v-model="uphone"
        ></el-input>
      </div>
      <div class="names">
        <span>邮箱：</span>
        <el-input
          @input="email"
          type="text"
          placeholder="请输入邮箱"
          v-model="uemail"
        ></el-input>
      </div>
      <div class="pa-t-20 pa-b-10 b-b-1 width40">
        性别：
        <el-radio-group @change="sex" v-model="usex" class="pa-l-10">
          <el-radio :label="2">男</el-radio>
          <el-radio :label="1">女</el-radio>
          <!-- <el-radio :label="3">保密</el-radio> -->
        </el-radio-group>
      </div>
      <div class="flex pa-t-20 pa-b-10 b-b-1 width40">
        微信：
        <div>
          <div class="pa-l-10" v-if="IsBindWx">已绑定</div>
          <div class="btn-bindWei c-p pa-l-10" @click="bindWei()" v-else>绑定微信</div>
        </div>
      </div>
    </div>
    <div class="btns">
      <div @click="tj" class="save">保存</div>
      <el-popover ref="pro" placement="right" width="350" trigger="click">
        <el-form ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="原密码" prop="pass"
            ><el-input
              @input="oldpassword"
              v-model="oldp"
              type="password"
              autocomplete="off"
            ></el-input
          ></el-form-item>
          <el-form-item label="新密码" prop="pass"
            ><el-input
              @input="newpassword"
              v-model="newp"
              type="password"
              autocomplete="off"
            ></el-input
          ></el-form-item>
          <el-form-item label="确认新密码" prop="checkPass"
            ><el-input
              @input="newpasswords"
              v-model="newsp"
              type="password"
              autocomplete="off"
            ></el-input
          ></el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm" class="green"
              >提交</el-button
            >
            <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
          </el-form-item>
        </el-form>
        <!-- <el-button slot="reference">修改密码</el-button> -->
      </el-popover>

      <el-dialog
        title="扫一扫绑定微信"
        :visible.sync="dialogVisible"
        width="30%"
      >
        <div class="ma-t-10">
          <img :src="bindWeiUrl" alt="" srcset="" />
        </div>
      </el-dialog>
      <el-dialog
        title="绑定手机号"
        :visible.sync="bindWeiXindialogVisible"
        width="30%"
        :close-on-click-modal="false"
      >
        <div class="pa-40">
            <el-input
              placeholder="请输入手机号"
              maxlength="11"
              prefix-icon="el-icon-phone-outline"
              v-model="phonenumber"
            ></el-input>
            <div class="verify">
              <el-input
                autocomplete="off"
                style="margin-top: 0px"
                placeholder="请输入验证码"
                prefix-icon="el-icon-key"
                v-model="phonecode"
                maxlength="4"
              ></el-input>
              <div
                @click.stop="sendSmsCode"
                class="zai-checking"
                v-if="state === false"
              >
                获取验证码
              </div>
              <div class="zai-checking zai-time" v-if="state === true">
                倒计时{{ currentTime }}s
              </div>
            </div>
          <div class="btn-weixin-bind c-p" @click="bindPhone()">绑定</div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getuser,
  changeuser,
  userchangepassword,
  aliupload,
  getBindWeiXin,
  getcodes,
  postBindPhone
} from "../api.js";
import axios from "axios";

export default {
  name: "User-message",
  props: {},
  data() {
    return {
      bindWeiXindialogVisible: false,
      bindWeiUrl: "",
      dialogVisible: false,
      fetch_static: false,
      imageUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      uname: "",
      uphone: "",
      uemail: "",
      usex: 5,
      id: "",
      newp: "",
      newsp: "",
      oldp: "",
      pro: false,
      nickName: "",
      IsBindWx: false,

      phonecode:'',//验证码
      phonenumber:'',//被绑定的手机号
      state: false, //是否开启倒计时
      totalTime: 120, //总时间，单位秒
      recordingTime: 0, //记录时间变量
      currentTime: 0, //显示时间变量
    };
  },
  created() {
    this.usermessage();
  },
  // 其他页面进来时更新初始数据
  activated() {
    if (this.$route.meta.title == "false") {
      this.usermessage();
    }
  },
  methods: {
    //绑定微信
    bindPhone(){
      var _this=this;
      let phone = this.phonenumber;
      var reg = 11 && /^((13|14|15|17|18|16|19|11|12)[0-9]{1}\d{8})$/;
      if (phone.length < 1) {
        this.$message.error("手机号不能为空哦！");
        return;
      } else if (!reg.test(phone)) {
        this.$message.error("手机格式不正确！");
        return;
      }
      if (!this.phonecode) {
        this.$message.error("验证码不能为空哦！");
        return;
      }
      postBindPhone({Phone:this.phonenumber,Code:this.phonecode}).then(res=>{
        if(res.data.Data){
          _this.bindWeiXindialogVisible=false
          this.usermessage();//重新获取数据
        }else{
          _this.$message.error("绑定失败");
        }
      })
    },
    // 手机短信验证码
    sendSmsCode() {
      let that = this;
      let phone = that.phonenumber;
      var reg = 11 && /^((13|14|15|17|18|16|19|11|12)[0-9]{1}\d{8})$/;
      if (phone.length < 1) {
        that.$message.error("手机号不能为空哦！");
        return;
      } else if (!reg.test(phone)) {
        that.$message.error("手机格式不正确！");
        return;
      }
      let phones = { Phone: phone, Source: "pc", Type: "7" };
      getcodes(phones).then((res) => {
        if (res.data.Code == 0) {
          that.$message({
            message: res.data.Data,
            type: "success",
          });
          // 把显示时间设为总时间
          that.currentTime = that.totalTime;
          //开始倒计时
          that.state = true;
          //执行倒计时
          that.checkingTime();
        } else {
          that.$message.error(res.data.Message);
        }
      });
    },
    // 验证码倒计时
    checkingTime() {
      let that = this;
      //判断是否开启
      if (this.state) {
        //判断显示时间是否已到0，判断记录时间是否已到总时间
        if (this.currentTime > 0 && this.recordingTime <= this.totalTime) {
          //记录时间增加 1
          this.recordingTime = this.recordingTime + 1;
          //显示时间，用总时间 - 记录时间
          this.currentTime = this.totalTime - this.recordingTime;
          //1秒钟后，再次执行本方法
          setTimeout(() => {
            //定时器内，this指向外部，找不到vue的方法，所以，需要用that变量。
            that.checkingTime();
          }, 1000);
        } else {
          //时间已完成，还原相关变量
          this.state = false; //关闭倒计时
          this.recordingTime = 0; //记录时间为0
          this.currentTime = this.totalTime; //显示时间为总时间
        }
      } else {
        //倒计时未开启，初始化默认变量
        this.state = false;
        this.recordingTime = 0;
        this.currentTime = this.totalTime;
      }
    },
    //绑定微信
    bindWei() {
      getBindWeiXin().then((res) => {
        console.log(res);
        this.bindWeiUrl = res.data.Data;
        this.dialogVisible = true;
      });
    },
    // 个人信息
    usermessage() {
      let token = localStorage.getItem("AccessToken");
      let datas = {
        token: token,

        source: "pc",
      };
      getuser(datas).then((res) => {
        console.log(res);
        if (res.data.Code == 0) {
          let result = res.data.Data;
          this.imageUrl = result.HeadImage;
          this.uname = result.Name;
          this.uphone = result.Phone;
          this.uemail = result.Email;
          this.usex = result.Gender;
          this.nickName = result.Nickname;
          this.IsBindWx = result.IsBindWx;
        }
      });
    },

    names(e) {
      this.uname = e;
      this.fetch_static = false;
    },
    phone(e) {
      this.uphone = e;
      this.fetch_static = false;
    },
    email(e) {
      this.uemail = e;
      this.fetch_static = false;
    },
    sex(e) {
      this.usex = e;
      this.fetch_static = false;
    },
    // 原密码
    oldpassword(e) {
      this.oldp = e;
    },
    // 新密码1
    newpassword(e) {
      this.newp = e;
    },
    // 确认密码
    newpasswords(e) {
      this.newsp = e;
    },

    // 修改密码
    submitForm() {
      let p1 = this.newp;
      let p2 = this.newsp;
      let token = localStorage.getItem("AccessToken");
      let oldp = localStorage.getItem("password");
      let oldps = this.oldp;

      if (oldps != oldp) {
        this.$message.error("原密码不正确");
        return;
      }

      if (p1 == "" || p2 == "") {
        this.$message.error("密码不能为空");
        return;
      }

      if (/[\u4E00-\u9FA5]/g.test(p1)) {
        this.$message.error("密码不能有汉字");
        return;
      }

      if (/[\u4E00-\u9FA5]/g.test(p2)) {
        this.$message.error("密码不能有汉字");
        return;
      }

      if (p1 != p2) {
        this.$message.error("二次密码不一致");
        return;
      }

      let datas = {
        Language: 1,
        Token: token,
        OldPassword: oldps,
        Password: p1,
        Password2: p2,
        Source: "pc",
      };

      userchangepassword(datas).then((res) => {
        // console.log(res)
        if (res.data.Code == 0) {
          this.$message({
            message: "密码修改成功",
            type: "success",
          });

          localStorage.setItem("password", p1);
          this.oldp = "";
          this.newp = "";
          this.newsp = "";
          this.$refs.pro.doClose();
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },

    // 保存
    tj() {
      let token = localStorage.getItem("AccessToken");
      let phone = this.uphone;
      let email = this.uemail;
      let name = this.uname;
      let sex = this.usex;
      let img = this.imageUrl;

      let regs =
        /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
      if (email.length < 1) {
        this.$message.error("请输入邮箱地址");
        return;
      }
      if (!regs.test(email)) {
        this.$message.error("邮箱格式不正确！");
        return;
      }

      if (name == "") {
        this.$message.error("请填写姓名！");
        return;
      }
      if (this.nickName == "") {
        this.$message.error("请填写昵称！");
        return;
      }
      let datas = {
        Name: name,
        Phone: phone,
        HeadImage: img,
        Email: email,
        Sex: sex,
        Source: "web",
        Nickname: this.nickName,
        Token: token,
      };

      changeuser(datas)
        .then((res) => {
          this.fetch_static = true;
          if (res.data.Code == 0) {
            localStorage.setItem("username", name);
            this.$message({
              message: "修改成功",
              type: "success",
            });
          } else {
            this.$message.error(res.data.Message);
          }
        })
        .catch((error) => {
          console.log(error);
          this.fetch_static = false;
        });
    },

    picUpload(file) {
      let that = this;
      let datas = {
        bucketName: "",
        area: "",
        folder: "User|Image",
      };
      aliupload(datas).then((res) => {
        if (res.data.Code == 0) {
          var formData = new FormData();
          let key = res.data.Data.Dir + res.data.Data.Key + file.file.name;
          formData.append("key", key);
          formData.append("OSSAccessKeyId", res.data.Data.OSSAccessKeyId);
          formData.append("policy", res.data.Data.Policy);
          formData.append("Signature", res.data.Data.Signature);
          formData.append("file", file.file);
          formData.append("success_action_status", 200);
          let url = res.data.Data.Host;
          let data = formData;
          let imgurl = url + "/" + key;

          axios({
            url: url,
            method: "post",
            data: data,
          }).then(function (datas) {
            console.log(datas);
            that.imageUrl = imgurl;
          });
        }
      });
    },

    beforeAvatarUpload(file) {
      this.fetch_static = false;
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
  },
};
</script>

<style lang="scss">
.green {
  background: #234775;
}
.user-message {
  .btn-weixin-bind{
    background: #234775;
    color: #fff;
    margin-top: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .verify {
      height: 40px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
      .el-input__inner {
        // width: 60%;
      }
      .zai-checking {
        height: 40px;
        width: 40%;
        line-height: 40px;
        text-align: center;
        font-size: 14px;
        color: #0f75bd;
        cursor: pointer;
      }
    }
  .b-b-1 {
    border-bottom: 1px solid #e6e6e6;
  }
  .el-dialog .el-dialog__header {
    padding-top: 16px;
  }
  .el-upload {
    width: 100%;
  }
  .el-popover {
    z-index: 8 !important;
  }
  .titles-right {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 24px;
  }
  .titles-right:before {
    content: "|";
    display: inline-block;
    width: 4px;
    height: 19px;
    background: #234775;
    color: #234775;
    border-radius: 2px;
    margin-right: 8px;
  }
  .message {
    height: 369px;
    margin-top: 43px;
    margin-bottom: 66px;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: rgba(51, 51, 51, 1);
    font-weight: 540;
    display: flex;
    flex-direction: column;
    // justify-content: space-around;
    .names {
      width: 40%;
      border-bottom: 1px solid #e6e6e6;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-top: 10px;
      // padding-bottom: 10px;
      span {
        width: 60px;
      }
      .el-input__inner {
        border: none;
      }
    }
    .userimg {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
      }
      .avatar-uploader {
        cursor: pointer;
        width: 126px;
        height: 32px;
        border-radius: 20px;
        border: 1px solid #234775;
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: #234775;
        text-align: center;
        line-height: 32px;
        margin-left: 23px;
      }
    }
  }
  .btns {
    text-align: center;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .save {
      width: 208px;
      height: 40px;
      border-radius: 20px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      line-height: 40px;
      color: #ffffff;
      background: #234775;
      margin-right: 40px;
      cursor: pointer;
    }
    .change {
      width: 208px;
      height: 40px;
      line-height: 40px;
      border-radius: 20px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      line-height: 40px;
      color: #234775;
      border: 1px solid #234775;
      display: flex;
      align-items: center;
    }
    .el-button {
      width: 208px;
      height: 40px;
      border: 1px solid #234775;
      color: #234775;
      border-radius: 20px;
    }
  }
}
</style>
